/* eslint-disable react-hooks/exhaustive-deps */
import { DeleteOutlined, EyeOutlined, FormOutlined } from "@ant-design/icons";
import { Card, Col, Row, Space, Typography } from "antd";
import React from "react";
import jwtDecode from "jwt-decode";
import { useNavigate } from "react-router-dom";

import styles from "./styles/notificationlist.module.css";
import { COLORS } from "../../../constants";
import moment from "moment";
import { deleteNotification } from "../../http-request/notification";
const { Text } = Typography;

const NotificationList = (props) => {
  // Deconstructing the props
  // Reason: UseLocation does not accept a whole object inside its state
  const { title, body, expires, expiresAt } = props;
  const token = localStorage.getItem("token");
  const loginas = jwtDecode(token).loginAs;
  const navigate = useNavigate();

  const DeleteNotification = async () => {
    await deleteNotification(props._id).then((res) => {
      if (res) {
        props.loadNotification();
      }
    });
  };
  return (
    <Card
      size="small"
      style={{
        width: "100%",
      }}
    >
      <Row align="middle" gutter={10}>
        <Col span={18}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Text strong className={styles.alignLeft}>
              {title}
            </Text>
            <Text className={styles.alignLeft}>
              Date Created: {moment(props.createdAt).fromNow()}
            </Text>
          </Space>
        </Col>

        {loginas === "Administrator" ? (
          <>
            <Col span={3}>
              <FormOutlined
                onClick={() => {
                  navigate(`/v2/Administrator/notification/${props._id}`, {
                    state: { title, body, expires, expiresAt },
                  });
                }}
                className={styles.icon}
                style={{ color: COLORS.blue }}
              />
            </Col>
            <Col span={3}>
              <DeleteOutlined
                onClick={DeleteNotification}
                className={styles.icon}
                style={{ color: COLORS.red }}
              />
            </Col>
          </>
        ) : (
          <Col span={6} style={{ justifyContent: "flex-end", display: "flex" }}>
            <EyeOutlined
              onClick={() =>
                navigate(`./${props._id}`, {
                  state: { title, body, expires, expiresAt },
                })
              }
              className={styles.icon}
              style={{ color: COLORS.blue }}
            />
          </Col>
        )}
      </Row>
    </Card>
  );
};

export default NotificationList;
